import { regulationId } from '@/utils/regulationLabels'

// Every assigned regulation, once each, the search regulation first (it is
// the one the preview falls back to, see the "Ensure previewRegulation"
// effect). Once each (#1184): an offering mapped under two operators is one
// regulation, and a target listed twice would be quoted and published twice.
export function defaultTargetRegulations(regulations = [], sourceRegulation = '') {
  const ids = [...new Set(regulations.map(regulationId).filter(Boolean))]
  if (!sourceRegulation || !ids.includes(sourceRegulation)) return ids
  return [sourceRegulation, ...ids.filter((id) => id !== sourceRegulation)]
}
